export default "__VITE_ASSET__zGQx6ty___"